module.exports = __webpack_public_path__ + "static/media/s6.eb6728ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s6.jpg
// module id = 9330
// module chunks = 0